<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    香蜜站<br>
站点介绍<br>
香蜜站位于侨香路与香蜜湖路的交叉路口的东侧，主要位于侨香路北侧道路及北侧绿化带内，大致呈东西走向。车站周边住宅区较多，如 北侧为枫丹雅苑、深水集团梅林水厂、豪峰苑； 南侧是香荟雅苑、新天国际名苑。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:24	00:04	2号线	2分35秒	5分45秒<br>
莲塘	06:05	23:36	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:29	00:03	2号线	4分钟	5分钟<br>
莲塘	06:05	23:36	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:29	00:53	2号线	4分钟	5分钟<br>
莲塘	06:05	00:36	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
B出入口:<br>
侨香路南侧、香蜜湖体育中心、香蜜湖豪庭、新天国际名苑、香荟雅苑、熙园、学苑大厦、深圳市委党校<br><br>
D出入口:<br>
侨香路北侧、枫丹雅苑、嘉园、恒星园、香雅园、香蜜湖瀚城、豪峰园、深水集团梅林水厂、温馨家园、香蜜公园<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 枫丹雅苑①<br>
44、73、104、316、323、B689、B928、M312、M398、高快巴士28号<br><br>
D出入口:<br>
公交站名： 枫丹雅苑②<br>
44、73、104、316、323、B689、M312、高快巴士28号<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>